"use strict";
/**
 * @module Serialisers
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * An abstract serialiser that implements {@link Serialiser.read} and
 * {@link Serialiser.write} withe methods that throw an error.
 */
var AbstractSerialiser = /** @class */ (function () {
    function AbstractSerialiser() {
    }
    /**
     * @inheritdoc
     *
     * @throws not implemented error
     */
    AbstractSerialiser.prototype.read = function (bis) {
        throw new Error('AbstractSerialiser#read is not implemented');
    };
    /**
     * @inheritdoc
     *
     * @throws not implemented error
     */
    AbstractSerialiser.prototype.write = function (bos, val) {
        throw new Error('AbstractSerialiser#write is not implemented');
    };
    return AbstractSerialiser;
}());
exports.AbstractSerialiser = AbstractSerialiser;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/serialisers/serialiser.js
// module id = 5
// module chunks = 0